import range from 'lodash/range';
import map from 'lodash/map';
import { compare } from 'utils/dateTools';
import {
  REQUEST_MANAGER_APPRAISAL,
  REQUEST_MANAGER_APPRAISAL_SUCCESS,
  REQUEST_MANAGER_APPRAISAL_FAILURE,
  SET_MANAGER_YEAR,
  SET_EMPLOYEE,
} from '../constants/ActionTypes';

const year = new Date().getFullYear();
export default function ManagerAppraisal(state = {
  appraisals: [],
  loading: false,
  error: null,
  year,
  yearOptions: range(year - 2, year + 2),
  employee: 0,
}, action) {
  switch (action.type) {
    case SET_MANAGER_YEAR:
      return {
        ...state,
        year: action.year,
      };
    case SET_EMPLOYEE:
      return {
        ...state,
        employee: action.employee,
      };
    case REQUEST_MANAGER_APPRAISAL:
      return {
        ...state,
        error: null,
        loading: true,
        appraisals: [],
      };
    case REQUEST_MANAGER_APPRAISAL_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        appraisals: action.appraisals.sort((a, b) => compare(a.ManagerDueDate, b.ManagerDueDate)),
        yearOptions: [...new Set([...map(action.appraisals, a => new Date(a.FinalAppraisalDate).getFullYear()).sort(), year])],
      };
    case REQUEST_MANAGER_APPRAISAL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        appraisals: [],
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ManagerAppraisal.js